module.exports = __webpack_public_path__ + "static/media/super-essencial.4e13db38.svg";